import { FieldViewModel } from "../fields"
import { omniaResolve } from "../promises"
import { SharedFieldsService } from "./service"

export function watchFields(svc: SharedFieldsService, $scope: ng.IScope, watcher: (fields: FieldViewModel[]) => void, includeDisabled: boolean = false) {

    const setup = () => {

        const onchange = () => {
            const fields = (svc.getFields(includeDisabled) || []).filter(f => f.visible)
            watcher(fields)
        }

        const unreg = $scope.$on("omnia.fields.filter", onchange)

        onchange()

        return unreg

    }

    if (svc.init) {
        const unreg = setup()
        return omniaResolve(unreg)
    }

    return svc.refresh().then(setup)

}
